import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone:true
})
export class InitialsPipe implements PipeTransform {

  transform(firstName: string | undefined, lastName?: string, userId?: string): string {
    if (firstName && lastName) {
      // If both firstName and lastName are provided, take first letters of both
      return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    } else if (firstName) {
      // If only firstName is provided, take first two letters of firstName
      return (firstName.charAt(0) + firstName.charAt(1)).toUpperCase();
    } else if (userId) {
      // Fallback to userId: take first two characters
      return (userId.charAt(0) + userId.charAt(1)).toUpperCase();
    }
    return '';
  }

}
